import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Show } from '../../Layout';
import { withRouter } from 'react-router';
import LoadingSpinner from "../../Layout/LoadingSpinner";
import { authRegistration, languageChange } from "./auth.actions";
import Language from "../../Languages/Login/content.json"
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import { registerDict } from 'Languages/RegistrationTranslations';
import { AuthAPI } from "../../API";
import signupindiapollsHeader from '../../assets/img/logoen-indiapolls.png';
import headerImage from '../../assets/img/signin-opinion.png';
import signUpImg from '../../assets/img/forwardarrow.png';
import arrowDownImg from '../../assets/img/arrowdown.png';
import hindiMainHeaderLogo from '../../assets/img/IndiaPolls-Hindi-Logo-without-BG.png';
import hindiSignUpImg from '../../assets/img/signuphindi.png';
import { checkNumberValidation, checkStrongPassword } from "../../Helper/Validations";
import { changePasswordDict } from 'Languages/ContactsTranslations';
import { myIpData } from 'Helper/EncryptionDecryption';
import SimpleCaptcha from "./Capcha";
import PropTypes from "prop-types";

const languageDropdownStyle = {
  position: 'fixed',
  top: '20px',
  right: '20px',
  zIndex: 3
};
class Registration extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      gender: '',
      password: '',
      confirmPassword: '',
      registerType: 'password',
      show: false,
      showConfirmPassword: false,
      phoneNumberActive: false,
      emailActive: false,
      passwordActive: false,
      confirmPasswordActive: false,
      isPasswordMatched: false,
      referralId: '',
      pageContent: this.props.language === 'hi' ? Language.SignupHindi : Language.SignupEnglish,
      error: {
        status: false,
        message: ''
      },

      captcha: false, // Initial captcha state
      isPasswordVisible: false,
      isRepeatPasswordVisible: false,
      email_otp: '',
      emailValid: false, // Track email validity
      phoneNumber: '',
      phoneOtp: '',
      phoneValid: false, // Track phone number validity
      isLoading: false, // Loader state
      countdown: 60, // Countdown in seconds
      isCountdownActive: false, // Track if countdown is active
      errorMessage: '',
      // Email verification state
      isEmailOtpValid: false,
      isLoadingEmail: false,
      showOtpSentMessage: false,
      isCountdownActiveEmail: false,
      countdownEmail: 60,
      errorMessageEmail: '',

      // Phone verification state
      isLoadingPhone: false,
      showOtpSentMessagePhone: false,
      isCountdownActivePhone: false,
      countdownPhone: 60,
      errorMessagePhone: '',
      isButtonDisabled: false, // Initially enabled
      showHideSelectBoxValue: false,
      isValidPassword: true,
      notValidPasswordText: "",
      isValidConfirmPassword: true,
      notValidConfirmPasswordText: "",
      isEmailValueChanged: false,
      isPhoneNumberChanged: false,
    };
    this.emailTimer = null;
    this.phoneTimer = null;
    this.setCaptcha = this.setCaptcha.bind(this);
    this.updateCaptcha = this.updateCaptcha.bind(this);
    this.checkDropdownClick = React.createRef();
  }

  setCaptcha(newCaptchaValue) {
    this.setState({ captcha: newCaptchaValue });
  }

  updateCaptcha(newCaptchaValue) {
    this.setState({ captcha: newCaptchaValue });
  }
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
    const fullUrl = window.location.href;
    const queryString = fullUrl.split('?')[1] || '';
    const urlSearchParams = new URLSearchParams(queryString);
    const referralId = urlSearchParams.get('referralId');
    if (referralId) {
      this.setState({ referralId })
    }
  }

  handleClickOutside = (event) => {
    if (this.checkDropdownClick.current && !this.checkDropdownClick.current.contains(event.target)) {
      this.setState({ showHideSelectBoxValue: false });
    }
  };

  validate(password, confirmPassword) {
    return password === confirmPassword
  }

  // ===================== Email Verificatiomn=========================
  componentWillUnmount() {
    clearInterval(this.emailTimer);
    clearInterval(this.phoneTimer);
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.error != this.props.error) {
      if (this.props.error && this.props.error !== '') {
        let errorMessage = '';

        switch (this.props.error) {
          case "Invalid Token":
            document.getElementById('view_tokenexpire').style.display = "block";
            document.getElementById('inputPsw1').style.display = "none";
            document.getElementById('inputPsw2').style.display = "none";
            document.querySelector('.privacy_error').style.display = "none";
            break;
          case "User registered successfully!":
            errorMessage = `${this.state.pageContent.items[32].title}`;
            break;
          case "Failed! email is already in use!":
            errorMessage = `${this.state.pageContent.items[28].title}`;
            break;
          case "Failed! phone number is already in use!":
            errorMessage = `${this.state.pageContent.items[29].title}`;
            break;
          case "Failed! Email does not exist!":
            errorMessage = `${this.state.pageContent.items[30].title}`;
            break;
          case "Invalid phone number. Only digits are allowed.":
            errorMessage = `${this.state.pageContent.items[31].title}`;
            break;
          case "Failed! your account has been deleted; for reactivation or a new account, please contact IndiaPolls support.":
            errorMessage = `${this.state.pageContent.items[34].title}`;
            break;
          default:
            errorMessage = 'An unknown error occurred.';
        }

        this.setState({
          error: {
            status: true,
            message: errorMessage
          },
          isButtonDisabled: false
        });
      } else {
        this.setState({
          isButtonDisabled: true,
          error: {
            status: false,
            message: ''
          }
        });
      }
    }
  };

  // ======================== EMAIL VERIFICATION ================================

  handleEmailChangenew = async (e) => {
    const { value } = e.target;
    await new Promise((resolve) =>
      this.setState({
        email: value,
        isEmailValueChanged: true,
        isEmailOtpValid: false,
        error: { status: false, message: '' }
      }, resolve)
    )
  }

  handleEmailChange = async (e) => {
    const { value } = e.target;
    await new Promise((resolve) =>
      this.setState((prevVal) => {
        if (prevVal.isEmailValueChanged) {
          return {
            email: value,
            emailValid: e.target.validity.valid,
            email_otp: '',
            showOtpSentMessage: false,
            countdownEmail: 60,
            isCountdownActiveEmail: false,
            errorMessageEmail: '',
          };
        } else {
          return { email: value };
        }
      }, resolve)
    );

    const { email, emailValid, isEmailValueChanged } = this.state;

    if (emailValid && isEmailValueChanged) {
      this.setState({ isLoadingEmail: true });
      try {
        const response = await AuthAPI.NewcontinueWithMobile({ email, type: "email", language: this.props.language });

        if (response.status === 1) {
          document.getElementById('email_otp_field').style.display = 'block';
          document.getElementById('email_text').style.display = 'none';

          this.startEmailTimer();
          this.setState({ showOtpSentMessage: true });
        } else {
          this.setState({ errorMessageEmail: response.message });
        }
      } catch (error) {
        console.error("An error occurred:", error);
        this.setState({ errorMessageEmail: "An error occurred while sending OTP." });
      } finally {
        this.setState({ isLoadingEmail: false, isEmailValueChanged: false });
      }
    }
  };
  startEmailTimer = () => {
    // Clear any existing interval timer
    if (this.emailTimer) {
      clearInterval(this.emailTimer);
    }

    this.setState({ isCountdownActiveEmail: true, countdownEmail: 60 });
    this.emailTimer = setInterval(() => {
      const { countdownEmail } = this.state;
      if (countdownEmail > 0) {
        this.setState({ countdownEmail: countdownEmail - 1 });
      } else {
        clearInterval(this.emailTimer);
        this.setState({ isCountdownActiveEmail: false });
      }
    }, 1000);
  };

  handleResendOtpEmail = async () => {
    const { email } = this.state;
    try {
      this.setState({ isLoadingEmail: true, showOtpSentMessage: false });
      const response = await AuthAPI.NewcontinueWithMobile({ email, type: "email", language: this.props.language });

      if (response.status === 1) {

        this.setState({ showOtpSentMessage: true, countdownEmail: 60, isCountdownActiveEmail: true });
        this.startEmailTimer();
      } else {
        this.setState({ errorMessageEmail: response.message });
      }
    } catch (error) {
      console.error("An error occurred while resending OTP:", error);
      this.setState({ errorMessageEmail: "An error occurred while resending OTP." });
    } finally {
      this.setState({ isLoadingEmail: false });
    }
  };

  handleVerifyEmailOtp = async () => {
    const { email, email_otp } = this.state;
    const data = {
      type: "email",
      otp: email_otp,
      email: email,
      language: this.props.language
    };

    try {
      this.setState({ isLoadingEmail: true });
      const response = await AuthAPI.newverifyMobile(data);

      if (response.status === 1) {
        document.getElementById('otpsend').style.display = 'none'; //otpsend
        document.getElementById('email_otp_field').style.display = 'none';
        document.getElementById('email_text').style.display = 'block';
        document.getElementById('invalidmsgmail').style.display = 'none';
        this.setState({
          showOtpSentMessage: false,
          errorMessageEmail: '',
          isEmailOtpValid: true,
        });
      } else {
        this.setState({ errorMessageEmail: "Invalid OTP. Please try again.", isEmailOtpValid: false });
      }
    } catch (error) {
      document.getElementById('invalidmsgmail').style.display = 'block';
      console.error("An error occurred:", error);
      this.setState({ errorMessageEmail: "An error occurred while verifying OTP.", isEmailOtpValid: false });
    } finally {
      this.setState({ isLoadingEmail: false });
    }
  };
  handleChange = async (e) => {
    const { name, value } = e.target;
    if (checkNumberValidation(e)) { return }
    if (name === 'email_otp' && value.length == 0) { document.getElementById('invalidmsgmail').style.display = 'none'; }
    await new Promise((resolve) =>
      this.setState({
        [name]: value.trim(),
        isEmailOtpValid: false,
      }, resolve)
    )
    // Automatically verify OTP when it reaches the required length
    if (name === 'email_otp' && value.length === 4) {
      this.handleVerifyEmailOtp();
    }
  };
  // ======================== PHONE VERIFICATION ================================
  handlePhoneNumberChange = async (e) => {
    const { value } = e.target;
    await new Promise((resolve) =>
      this.setState({
        phoneNumber: value.trim(),
        isPhoneNumberChanged: true,
        error: { status: false, message: '' }
      }, resolve)
    )
  }
  handlePhoneChange = async (e) => {
    document.getElementById('phone_otp_field').style.display = "block";
    document.getElementById('phone_text').style.display = "none";
    const { value } = e.target;
    if (checkNumberValidation(e)) { return }
    await new Promise((resolve) =>
      this.setState((prevVal) => {
        if (prevVal.isPhoneNumberChanged) {
          return {
            phoneNumber: value.trim(),
            phoneValid: e.target.validity.valid && value.length === 10,
            phoneOtp: '', // Clear OTP when phone number changes
            showOtpSentMessagePhone: false,
            countdownPhone: 60,
            isCountdownActivePhone: false,
            errorMessagePhone: '',
          }
        } else {
          return { phoneNumber: value.trim() }
        }
      }, resolve)
    )

    if (this.state.phoneValid && this.state.isPhoneNumberChanged) {
      this.setState({ isLoadingPhone: true });
      try {
        const response = await AuthAPI.NewcontinueWithMobile({ phoneNumber: this.state.phoneNumber, type: "mobile", language: this.props.language });

        if (response.status === 1) {

          this.startPhoneTimer();
          this.setState({ showOtpSentMessagePhone: true });
        } else {
          this.setState({ errorMessagePhone: response.message });
        }
      } catch (error) {
        console.error("An error occurred:", error);
        this.setState({ errorMessagePhone: "An error occurred while sending OTP." });
      } finally {
        this.setState({ isLoadingPhone: false, isPhoneNumberChanged: false });
      }
    }
  };
  startPhoneTimer = () => {
    if (this.phoneTimer) {
      clearInterval(this.phoneTimer);
    }

    this.setState({ isCountdownActivePhone: true, countdownPhone: 60 });
    this.phoneTimer = setInterval(() => {
      const { countdownPhone } = this.state;
      if (countdownPhone > 0) {
        this.setState({ countdownPhone: countdownPhone - 1 });
      } else {
        clearInterval(this.phoneTimer);
        this.setState({ isCountdownActivePhone: false });
      }
    }, 1000);
  };

  handleResendOtpPhone = async () => {
    const { phoneNumber } = this.state;
    try {
      this.setState({ isLoadingPhone: true, showOtpSentMessagePhone: false });
      const response = await AuthAPI.NewcontinueWithMobile({ phoneNumber, type: "mobile", language: this.props.language });

      if (response.status === 1) {

        this.setState({ showOtpSentMessagePhone: true, countdownPhone: 60, isCountdownActivePhone: true });
        this.startPhoneTimer();
      } else {
        console.error("Failed to resend OTP:", response.message);
      }
    } catch (error) {

      console.error("An error occurred while resending OTP:", error);
    } finally {
      this.setState({ isLoadingPhone: false });
    }
  };

  handleVerifyPhoneOtp = async () => {
    const { phoneNumber, phoneOtp } = this.state;
    const data = {
      type: 'mobile',
      phoneNumber: phoneNumber,
      otp: phoneOtp,
      language: this.props.language
    };

    try {
      this.setState({ isLoadingPhone: true });
      const response = await AuthAPI.newverifyMobile(data);

      if (response.status === 1) {
        document.getElementById('inputPsw1').style.display = "block";
        document.getElementById('inputPsw2').style.display = "block";
        document.getElementById('phone_text').style.display = "block";
        document.getElementById('phone_otp_field').style.display = "none";
        document.getElementById('invalidmsphone').style.display = "none";
        this.setState({
          showOtpSentMessagePhone: false,
          errorMessagePhone: '',
        });
      } else {
        console.error(`Unexpected status code: ${response.status}`);
        this.setState({ errorMessagePhone: "Invalid OTP. Please try again." });
      }
    } catch (error) {
      document.getElementById('invalidmsphone').style.display = "block";
      console.error("An error occurred:", error);
      this.setState({ errorMessagePhone: "An error occurred while verifying OTP." });
    } finally {
      this.setState({ isLoadingPhone: false });
    }
  };
  handleOtpChange = async (e) => {
    const { value } = e.target; 
    if (checkNumberValidation(e)) { return }
    await new Promise((resolve) => 
      this.setState({
        phoneOtp: value.trim(),
      }, resolve)
    )
    if (value.length < 1) { document.getElementById('invalidmsphone').style.display = "none"; }
    if (e.target.validity.valid && value.length === 4) {
      this.handleVerifyPhoneOtp();
    }
  };

  onSubmit() {
    this.setState({ isButtonDisabled: true }, () => {
      // Check if policy is accepted
      if (!this.state.policy) {
        this.setState({ show: true, isButtonDisabled: false }, () => {
        });
        return;
      }
      // Validate passwords
      if (!this.validate(this.state.password, this.state.confirmPassword)) {
        this.setState({ showConfirmPassword: true, isButtonDisabled: false }, () => {
        });
        return;
      }
      // Check if captcha is completed
      if (!this.state.captcha) {
        this.setState({
          error: {
            status: true,
            message: 'Please complete the captcha.'
          },
          isButtonDisabled: false
        }, () => {
        });
        return;
      }

      // Prepare data for registration
      const data = {
        email: this.state.email,
        phoneNumber: this.state.phoneNumber,
        password: this.state.password,
        registerType: this.state.registerType,
        role: myIpData("panelist"),
        referralId: this.state.referralId,
        language: this.props.language,
        mobileOTP: this.state.phoneOtp,
        emailOTP: this.state.email_otp,
      };

      const getUrlParam = window.location.href.split('&')[1];
      if (getUrlParam) {
        let regType = getUrlParam.split("=")[1];
        data.regType = regType;
      }
      // Call the registration function
      this.props.authRegistration(data, this.props.history);
    });
  }

  isSubmitButtonDisable() {
    return !!this.state.email &&
      !!this.state.phoneNumber &&
      !!this.state.password &&
      !!this.state.confirmPassword &&
      !!this.state.captcha &&
      !!this.state.isEmailOtpValid
  }

  isPasswordStrong(ele, type) {
    const { value } = ele.target;
    const isHindi = this.props.language === 'hi';
    if (value === "") {
      const stateUpdate = {
        [type === "password" ? 'isValidPassword' : 'isValidConfirmPassword']: true,
        [type === "password" ? 'notValidPasswordText' : 'notValidConfirmPasswordText']: "",
        isButtonDisabled: false
      };
      this.setState(stateUpdate);
      return;
    }
    const passwordChecks = checkStrongPassword(ele);
    const getLabel = () => {
      if (type === 'password') { return isHindi ? "पासवर्ड" : "Password"; }
      return isHindi ? "कन्फर्म पासवर्ड" : "Confirm password";
    };
    const errorMessages = [
      {
        condition: passwordChecks.capitalLatterCheck,
        message: isHindi ? " में एक बड़ा अक्षर होना चाहिए" : " should contain one capital letter"
      },
      {
        condition: passwordChecks.smallLatterCheck,
        message: isHindi ? " में एक छोटा अक्षर होना चाहिए" : " should contain one small letter"
      },
      {
        condition: passwordChecks.numericValCheck,
        message: isHindi ? " में एक संख्यात्मक मान होना चाहिए" : " should contain one numeric value"
      },
      {
        condition: passwordChecks.specialCharCheck,
        message: isHindi ? " में एक विशेष प्रतीक होना चाहिए" : " should contain one special character"
      },
      {
        condition: passwordChecks.lengthCheck,
        message: isHindi ? " की लंबाई कम से कम 8 अक्षर की होनी चाहिए" : " length should be atleast of 8 character"
      },
    ];
    const firstFailed = errorMessages.find(error => !error.condition);
    const isAllValid = errorMessages.every(error => error.condition);
    const label = getLabel();
    const stateUpdate = {
      [type === "password" ? 'isValidPassword' : 'isValidConfirmPassword']: isAllValid,
      [type === "password" ? 'notValidPasswordText' : 'notValidConfirmPasswordText']: isAllValid ? "" : label + firstFailed.message,
      isButtonDisabled: !isAllValid
    };
    this.setState(stateUpdate);
  }

  onChangePassword(value, type) {

    let { password, confirmPassword } = this.state;
    if (type === 'confirmpassword') {
      confirmPassword = value;
    } else {
      password = value;
    }

    if (password !== '' && confirmPassword !== '' && password === confirmPassword) {
      this.setState({
        isPasswordMatched: true
      })
    } else {
      this.setState({
        isPasswordMatched: false
      })
    }
  }

  onLogin() {
    if (this.state.referralId) {
      const queryParams = {
        referralId: this.state.referralId,
      };
      const queryString = Object.keys(queryParams)
        .map(key => `${key}=${encodeURIComponent(queryParams[key])}`)
        .join('&');
      const loginUrl = `/auth/login?${queryString}`;
      this.props.history.push(loginUrl)
    } else {
      this.props.history.push('/login')
    }
  }

  clickOnSelectBox() { this.setState({ showHideSelectBoxValue: true }); }

  selectDropdownValue(val) {
    this.setState({ showHideSelectBoxValue: false });
    if (this.props.language != val) {
      this.props.languageChange(val);
      setTimeout(() => { window.location.reload(); }, 33);
    }
  }



  render() {
    const conditionalVarObj = {
      true: {
        "mainCardPadding": "p-3",
        "headerImgWidth": "30%",
        "allParagraph": '20px',
        "allVisibleBtn": "25px",
        "partition": "या",
        "inputPsIcon": "fa fa-eye-slash",
        "newUserPadding": "0.3rem",
        "fbText": "फेसबुक से जुड़ें",
        "inputPsType": "text",
        "respoMsg": "18px",
        "password": "पासवर्ड",
        "confirmPassword": "कन्फर्म पासवर्ड",
        "checkBoxSize": "18px",
      },
      false: {
        "mainCardPadding": "p-2",
        "headerImgWidth": "13%",
        "allParagraph": '16px',
        "allVisibleBtn": "16px",
        "partition": "OR",
        "inputPsIcon": "fa fa-eye",
        "newUserPadding": "0.1rem",
        "fbText": "Connect with facebook",
        "inputPsType": "password",
        "respoMsg": "16px",
        "password": "Password",
        "confirmPassword": "Confirm password",
        "checkBoxSize": "12px",
      },
    };
    const {
      email,
      emailValid,
      email_otp,
      countdownEmail,
      showOtpSentMessage,
      isCountdownActiveEmail,
      errorMessage: errorMessageEmail, // Renamed errorMessage to avoid naming conflict
    } = this.state;

    const {
      showOtpSentMessagePhone,
      phoneNumber,
      phoneValid,
      phoneOtp,
      isLoadingPhone,
      isCountdownActivePhone,
      countdownPhone,
      errorMessage: errorMessagePhone, // Renamed errorMessage to avoid naming conflict
    } = this.state;
    const selectedLanguage = this.props.language === "hi" ? "हिंदी" : "English";


    const { isPasswordMatched, pageContent, isValidPassword, notValidPasswordText, isValidConfirmPassword, notValidConfirmPasswordText, } = this.state;
    const lang = this.props.language ?? 'en';
    return (
      <>
        <Helmet>
          <title>Indiapolls - Sign up</title>
        </Helmet>
        <section className="formSec">
          {/* <GridContainer> */}
          <div className='w-100' style={{ position: "fixed", zIndex: "1" }}>
            <div className='w-100 mb-2' style={{ boxShadow: "0px 2px 3px 1px rgba(0, 0, 0, 0.3), 4px 0px 12px 0px rgba(0, 0, 0, 0.3)", zIndex: "1" }}>
              <div className={`card ${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["mainCardPadding"]}`}>
                <div className="d-flex align-items-center justify-content-center">
                  <img src={lang == "hi" ? hindiMainHeaderLogo : signupindiapollsHeader} className="" alt="IndiaPolls" style={{ width: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["headerImgWidth"]}` }} />
                </div>
              </div>
            </div>
          </div>
          {/* </GridContainer> */}
          <div className="container zoom-70">
            <div className='col-md-5 m-auto'>
              <div>
                <img src={lang == "hi" ? hindiSignUpImg : headerImage} className="w-100 customImageCss" alt="IndiaPolls Header" />
              </div>
            </div>
            <div className="row" style={{ paddingTop: '2%' }}>
              <div className="col-sm-12 col-md-5 col-lg-5 m-0 m-auto">
                <div className="card card-body pt-1 mb-5 shadow" style={{ backgroundColor: "rgb(250, 250, 250, 0.95)", borderTop: "3rem solid rgb(245 130 50)", borderRadius: "0.75rem" }}>
                  <h3 style={{ color: "#046A38", fontWeight: "700", opacity: "1", marginBottom: "0px" }}>{pageContent.items[0].title}</h3>
                  <p style={{ color: "rgb(58, 58, 58)", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allParagraph"]}` }}>{pageContent.items[1].title}<Link to="#" onClick={() => this.onLogin()} className='text-white' style={{ backgroundColor: "#046A38", borderRadius: "0.5rem", textDecoration: "none", padding: `${conditionalVarObj[lang === "hi"]["newUserPadding"]} 0.5rem 0.3rem 0.5rem` }}>{pageContent.items[2].title}</Link></p>
                  <div className="social-login">
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999' }}>
                      {this.state.isLoadingEmail && (
                        <img style={{ height: "415px", }}
                          src="../loadernew.gif"
                          alt="Loading..."
                        />
                      )}
                    </div>
                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999' }}>
                      {isLoadingPhone && (
                        <img style={{ height: "415px", }}
                          src="../loadernew.gif"
                          alt="Loading..."
                        />
                      )}
                    </div>
                  </div>
                  <form onSubmit={(e) => {
                    e.preventDefault();
                    this.onSubmit();
                  }}>

                    {/* Email Verification Section */}
                    <div className="mb-3 mt-3">
                      <input
                        type="email"
                        className={`form-control`}
                        style={{ border: "1px solid rgb(170, 170, 170)", borderRadius: "0.75rem", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allVisibleBtn"]}` }}
                        name="email"
                        value={email}
                        onBlur={this.handleEmailChange}
                        onChange={this.handleEmailChangenew}
                        maxLength={200}
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                        required
                        placeholder={pageContent.items[5].title}
                      />
                      {!emailValid && (
                        <div className="invalid-feedback">
                          {pageContent.items[19].title}
                        </div>
                      )}

                      <div className="text-green mt-2" style={{ display: showOtpSentMessage ? 'block' : 'none', fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }} id='otpsend'>
                        {pageContent.items[23].title} ({pageContent.items[24].title} {countdownEmail} sec)
                        <button
                          className='mx-2 mt-2'
                          type='button'
                          onClick={this.handleResendOtpEmail}
                          disabled={isCountdownActiveEmail}
                        >
                          {pageContent.items[25].title}
                        </button>
                      </div>
                      <div className="text-green mt-2" style={{ display: 'none', fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }} id='email_text'>
                        {pageContent.items[21].title}
                      </div>
                    </div>

                    <div className="mb-3 mt-3" id='email_otp_field' >
                      <input
                        type="text"
                        className="form-control"
                        style={{ border: "1px solid rgb(170, 170, 170)", borderRadius: "0.75rem", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allVisibleBtn"]}` }}
                        name="email_otp"
                        value={email_otp}
                        onChange={this.handleChange}
                        maxLength={4}
                        onInput={(e) => e.target.setCustomValidity('')}
                        required
                        placeholder={pageContent.items[15].title}
                      />
                      <div className="text-red mt-2" style={{ display: 'none', fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }} id='invalidmsgmail'>
                        {pageContent.items[22].title}
                      </div>
                    </div>

                    {/* Phone Verification Section */}
                    <div className="mb-3 mt-3">
                      <input
                        type="text"
                        className={`form-control`}
                        style={{ border: "1px solid rgb(170, 170, 170)", borderRadius: "0.75rem", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allVisibleBtn"]}` }}
                        name="phone"
                        value={phoneNumber}
                        onChange={this.handlePhoneNumberChange}
                        onBlur={this.handlePhoneChange}
                        maxLength={10}
                        pattern="[6-9]\d{9}"
                        required
                        placeholder={pageContent.items[6].title}
                        onInvalid={(e) => {
                          e.target.setCustomValidity(`${pageContent.items[26].title} `);
                        }}
                        onInput={(e) => e.target.setCustomValidity('')}
                      />

                      {!phoneValid && (
                        <div className="invalid-feedback">
                          {pageContent.items[17].title}
                        </div>
                      )}

                      <div className="text-green mt-2" style={{ display: showOtpSentMessagePhone ? 'block' : 'none', fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }} id='otpsend'>
                        {pageContent.items[23].title} (  {pageContent.items[24].title} {countdownPhone} sec)
                        <button
                          className='mx-2'
                          type='button'
                          onClick={this.handleResendOtpPhone}
                          disabled={isCountdownActivePhone}
                        >
                          {pageContent.items[25].title}
                        </button>
                      </div>
                    </div>

                    <div className="text-green" style={{ display: "none", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }} id='phone_text'>
                      {pageContent.items[20].title}
                    </div>

                    <div className="mb-3 mt-3" id='phone_otp_field'>
                      <input
                        type="text"
                        className={`form-control`}
                        style={{ border: "1px solid rgb(170, 170, 170)", borderRadius: "0.75rem", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allVisibleBtn"]}` }}
                        name="phoneOtp"
                        value={phoneOtp}
                        onChange={this.handleOtpChange}
                        maxLength={4}
                        pattern="\d{4}"
                        required
                        placeholder={pageContent.items[16].title}
                        onInvalid={(e) => {
                          e.target.setCustomValidity(`${pageContent.items[18].title}`);
                        }}
                        onInput={(e) => e.target.setCustomValidity('')}
                      />
                      {!phoneValid && (
                        <div className="invalid-feedback">
                          {pageContent.items[18].title}
                        </div>
                      )}
                      <div className="text-red mt-2" style={{ display: 'none', fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }} id='invalidmsphone'>
                        {pageContent.items[22].title}
                      </div>
                    </div>

                    {/* Error Message Display */}
                    {(errorMessageEmail || errorMessagePhone) && (
                      <div className="text-red mt-2" style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }}>
                        {errorMessageEmail || errorMessagePhone}
                      </div>
                    )}

                    <div className="mb-3 mt-3" id='inputPsw1' style={{ display: "none" }}> 
                      <div className="password-container" style={{ position: 'relative', }}>
                        <input
                          className="form-control"
                          style={{ border: "1px solid rgb(170, 170, 170)", borderRadius: "0.75rem", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allVisibleBtn"]}` }}
                          name='password'
                          value={this.state.password}  // Ensure value is set to state
                          type={conditionalVarObj[this.state.isPasswordVisible]["inputPsType"]}
                          onChange={(e) => {
                            this.onChangePassword(e.target.value, 'password');
                            this.setState({ password: e.target.value, })
                          }}
                          onClick={() => this.setState((prev) => { return { ...prev, passwordActive: !prev.passwordActive } })}
                          title={registerDict[lang]['passwordTitle']}
                          pattern="^(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,20}$"
                          onInvalid={(e) => {
                            let msg = registerDict[lang]['validationMessage'] + ': ' + registerDict[lang]['passwordTitle']
                            e.target.setCustomValidity(msg)
                          }}
                          onInput={(e) => this.isPasswordStrong(e, 'password')}
                          placeholder={conditionalVarObj[lang == "hi"]["password"]}
                          required />
                        <button
                          type="button"
                          style={{ position: 'absolute', top: '50%', backgroundColor: "white", right: '10px', transform: 'translateY(-50%)' }}
                          onClick={() => this.setState((prev) => { return { ...prev, isPasswordVisible: !prev.isPasswordVisible } })}
                          className={this.state.password.length > 0 ? "bg-transparent" : "d-none"}
                        >
                          <i className={conditionalVarObj[!this.state.isPasswordVisible]["inputPsIcon"]}></i>
                        </button>
                      </div>
                      {isValidPassword ? "" :
                        <div className="text-red mt-2" style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }}>
                          {notValidPasswordText}
                        </div>}
                    </div>
                    <div className="mb-3" id='inputPsw2' style={{ display: "none" }}>
                      <div className="password-container" style={{ position: 'relative', }}>
                        <input
                          className="form-control"
                          style={{ border: "1px solid rgb(170, 170, 170)", borderRadius: "0.75rem", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allVisibleBtn"]}` }}
                          name='confirmpassword'
                          value={this.state.confirmPassword}  // Ensure value is set to state
                          type={conditionalVarObj[this.state.isRepeatPasswordVisible]["inputPsType"]}
                          pattern="^(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,20}$"
                          onInvalid={(e) => {
                            let msg = registerDict[lang]['validationMessage'] + ': ' + registerDict[lang]['passwordTitle']
                            e.target.setCustomValidity(msg)
                          }}
                          onInput={(e) => this.isPasswordStrong(e, 'confirmpassword')}
                          onChange={(e) => {
                            this.onChangePassword(e.target.value, 'confirmpassword');
                            this.setState({ confirmPassword: e.target.value, })
                          }}
                          onClick={() => this.setState((prev) => { return { ...prev, confirmPasswordActive: !prev.confirmPasswordActive } })}
                          placeholder={conditionalVarObj[lang == "hi"]["confirmPassword"]}
                        />
                        <button
                          type="button"
                          style={{ position: 'absolute', top: '50%', backgroundColor: "white", right: '10px', transform: 'translateY(-50%)' }}
                          onClick={() => this.setState((prev) => { return { ...prev, isRepeatPasswordVisible: !prev.isRepeatPasswordVisible } })}
                          className={this.state.confirmPassword.length > 0 ? "bg-transparent" : "d-none"}
                        >
                          <i className={conditionalVarObj[!this.state.isRepeatPasswordVisible]["inputPsIcon"]}></i>
                        </button>
                      </div>
                      {isPasswordMatched && isValidPassword && isValidConfirmPassword ?
                        <div className="text-success mt-2" style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }}>
                          <i className="fa fa-check"></i> &nbsp;{changePasswordDict[lang]["Passwords Matched"] || "Passwords matched!"}
                        </div> : ""}
                      {!isPasswordMatched && this.state.password && this.state.confirmPassword && isValidConfirmPassword ?
                        <div className="text-red mt-2" style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }}>
                          <i className="fa fa-x text-danger"></i> &nbsp;{changePasswordDict[lang]["Not Matched"] || "Not Matched"}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        </div> : ""}
                      {isValidConfirmPassword ? "" :
                        <div className="text-red mt-2" style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["respoMsg"]}` }}>
                          {notValidConfirmPasswordText}
                        </div>}
                    </div>
                    <div className="login-row login-form-item-control" style={{ marginBottom: '-11px', fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allParagraph"]}` }}>
                      <label className="custom-checkbox">
                        <input type="checkbox"
                          name='myCheckbox'
                          onChange={(e) => this.setState({ policy: e.target.checked })}
                          required
                          onInvalid={(e) => {
                            let msg = registerDict[lang]['acceptance_required'];
                            e.target.setCustomValidity(msg)
                          }}
                          onInput={(e) => e.target.setCustomValidity("")}
                        />
                        <span className="checkmark">.</span>
                        <span
                          dangerouslySetInnerHTML={{ __html: pageContent.items[9].title || "I agree to the Privacy Policy." }}
                          className="mx-2"
                          style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["checkBoxSize"]}` }}
                        />
                      </label>
                    </div>
                    <div className="mt-2 mb-2">

                    </div>
                    {/* token expire div view  */}
                    <div className="alert alert-danger" id='view_tokenexpire' role="alert" style={{ display: 'none' }} >
                      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                        <p>{pageContent.items[33].title}</p>
                        <button type='button' className='mx-2 btn btn btn-outline-danger' onClick={() => window.location.reload()}>ok</button>
                      </div>
                    </div>

                    <Show when={this.state.show === true}>
                      <p className="form-text text-danger privacy_error">
                        {pageContent.items[13].title}
                      </p>
                    </Show>
                    <Show when={this.state.showConfirmPassword === true}>
                      <p className="form-text text-danger privacy_error">
                        {pageContent.items[14].title}
                      </p>
                    </Show>
                    <Show when={this.state.error.status === true}>
                      <p className="form-text text-danger privacy_error">
                        {this.state.error.message}
                      </p>
                    </Show>
                    <p>
                      <SimpleCaptcha onValid={this.setCaptcha} updateCaptcha={this.updateCaptcha} language={this.props.language} style={{ borderRadius: "0.75rem", fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allVisibleBtn"]}` }} />

                      <LoadingSpinner show={this.props.isLoading} />
                      <span className="text-right" style={{ fontSize: `${conditionalVarObj[window.matchMedia("(max-width: 768px)").matches]["allParagraph"]}` }}>
                        <button
                          type="submit"
                          style={{ float: 'right', borderRadius: "1.5rem", backgroundColor: "#515356", color: "#fff", paddingLeft: "16px" }}
                          className="mt-3"
                          onClick={this.handleButtonClick}
                          disabled={this.state.isButtonDisabled || !this.isSubmitButtonDisable()}
                        >
                          <span style={{ display: "flex", alignItems: "center" }}>
                            {pageContent.items[11].title} &nbsp;<img src={signUpImg} className="" alt="IndiaPolls Header" width={"20rem"} />
                          </span>
                        </button>
                      </span>

                      <button type='button' className="mt-3 px-3" onClick={() => { this.clickOnSelectBox() }} style={{ width: "30%", display: "flex", justifyContent: "space-evenly", alignItems: "center", border: "1px solid rgb(170, 170, 170)", borderRadius: "0.6rem", cursor: "pointer", position: "relative" }} ref={this.checkDropdownClick}>
                        <span>{selectedLanguage}</span> &nbsp;<img src={arrowDownImg} className="" alt="Arrow Down" width={"15rem"} />
                      </button>
                      <div style={{ position: "absolute", display: `${this.state.showHideSelectBoxValue ? "" : "none"}` }} ref={this.checkDropdownClick}>
                        <div className='d-flex flex-column'>
                          <button type='button' onClick={() => { this.selectDropdownValue("en") }} style={{ borderTop: "1px solid rgb(170, 170, 170)", margin: "0px", padding: '0px', width: "8rem", textAlign: "center", background: "#fff", borderLeft: "1px solid rgb(170, 170, 170)", borderRight: "1px solid rgb(170, 170, 170)", cursor: "pointer" }}>English</button>
                          <button type='button' onClick={() => { this.selectDropdownValue("hi") }} style={{ border: "1px solid rgb(170, 170, 170)", margin: "0px", padding: '0px', width: "8rem", textAlign: "center", background: "#fff", cursor: "pointer" }}>हिंदी</button>
                        </div>
                      </div>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuth: state.adminUser.adminUser.isAuthenticated,
    token: state.adminUser.adminUser.token,
    language: state.adminUser.adminUser.language,
    isLoading: state.adminUser.adminUser.loading,
    error: state.adminUser.adminUser.error,
  };
};

const RegistrationWithState = withRouter(connect(
  mapStateToProps, { authRegistration, languageChange },
)(Registration));

Registration.propTypes = {
  language: PropTypes.string,
  isLoading: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  authRegistration: PropTypes.func,
  languageChange: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
};

export {
  Registration,
  RegistrationWithState,
};
